import React from "react";

import { ReactComponent as LetterA } from "src/images/svg/LetterA.svg";
import { ReactComponent as LetterB } from "src/images/svg/LetterB.svg";
import { ReactComponent as LetterC } from "src/images/svg/LetterC.svg";
import { ReactComponent as LetterD } from "src/images/svg/LetterD.svg";
import { ReactComponent as LetterE } from "src/images/svg/LetterE.svg";
import { ReactComponent as LetterF } from "src/images/svg/LetterF.svg";
import { ReactComponent as LetterG } from "src/images/svg/LetterG.svg";
import { ReactComponent as LetterH } from "src/images/svg/LetterH.svg";
import { ReactComponent as LetterI } from "src/images/svg/LetterI.svg";
import { ReactComponent as LetterJ } from "src/images/svg/LetterJ.svg";
import { ReactComponent as LetterK } from "src/images/svg/LetterK.svg";
import { ReactComponent as LetterL } from "src/images/svg/LetterL.svg";
import { ReactComponent as LetterM } from "src/images/svg/LetterM.svg";
import { ReactComponent as LetterN } from "src/images/svg/LetterN.svg";
import { ReactComponent as LetterO } from "src/images/svg/LetterO.svg";
import { ReactComponent as LetterP } from "src/images/svg/LetterP.svg";
import { ReactComponent as LetterQ } from "src/images/svg/LetterQ.svg";
import { ReactComponent as LetterR } from "src/images/svg/LetterR.svg";
import { ReactComponent as LetterS } from "src/images/svg/LetterS.svg";
import { ReactComponent as LetterT } from "src/images/svg/LetterT.svg";
import { ReactComponent as LetterU } from "src/images/svg/LetterU.svg";
import { ReactComponent as LetterV } from "src/images/svg/LetterV.svg";
import { ReactComponent as LetterW } from "src/images/svg/LetterW.svg";
import { ReactComponent as LetterX } from "src/images/svg/LetterX.svg";
import { ReactComponent as LetterY } from "src/images/svg/LetterY.svg";
import { ReactComponent as LetterZ } from "src/images/svg/LetterZ.svg";
import { ReactComponent as Number } from "src/images/svg/Number.svg";

const letters = {
	A: LetterA,
	B: LetterB,
	C: LetterC,
	D: LetterD,
	E: LetterE,
	F: LetterF,
	G: LetterG,
	H: LetterH,
	I: LetterI,
	J: LetterJ,
	K: LetterK,
	L: LetterL,
	M: LetterM,
	N: LetterN,
	O: LetterO,
	P: LetterP,
	Q: LetterQ,
	R: LetterR,
	S: LetterS,
	T: LetterT,
	U: LetterU,
	V: LetterV,
	W: LetterW,
	X: LetterX,
	Y: LetterY,
	Z: LetterZ,
	Number: Number,
};

export const Letter = ({ letter }: { letter: string }) => {
	const SVG = letter === "ZNumber" ? Number : letters[letter];

	return <SVG />;
};
